import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';



@Injectable({
  providedIn: 'root'
})
export class SectorTypeService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }
  GetSectorType():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/SectorType/Get`);
  }

  DeleteSectorType(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/SectorType/Delete?id=${id}`);
  }

  CreateSectorType(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/SectorType/Create`,data);
  }
  UpdateSectorType(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/SectorType/Update`,data)
  }
}
